import { useEffect, useState } from 'react'

import { localStorageService, sessionStorageService } from '@/service/storage.service'

type AppState = 'NOT_INITIALIZED' | 'INITIALIZING' | 'INITIALIZED'

export const useLifeCycle = () => {
  const [appState, setAppState] = useState<AppState>('NOT_INITIALIZED')

  useEffect(() => {
    if (appState === 'NOT_INITIALIZED') {
      setAppState('INITIALIZING')
      return
    }

    if (appState === 'INITIALIZING') {
      initializeApp()
      return
    }
  }, [appState])

  const initializeApp = async () => {
    try {
      await Promise.all([
        localStorageService.initializeStorage(),
        sessionStorageService.initializeStorage(),
      ])
    } catch (e) {
      console.error(e)
    }

    setAppState('INITIALIZED')
  }

  return appState
}
